import { CubePresenter, FlipIntent, Logger } from 'wdc-cube'

import { MainPresenter } from 'src/main/Main.presenter'
import grupoService from 'src/modules/motor-credito/grupo/grupo.service'
import BorderoKeys from '../bordero.keys'
import borderoService from '../bordero.service'
import { BorderoEnvio } from '../bordero.types'
import { BorderoFormKeys } from './bordero_form.keys'
import BorderoFormScope from './bordero_form.scopes'

const LOG = Logger.get('BorderoFormPresenter')

export class BorderoFormPresenter extends CubePresenter<MainPresenter, BorderoFormScope> {
    // :: Constructor
    public constructor(app: MainPresenter) {
        super(app, new BorderoFormScope())
    }

    public override release() {
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new BorderoFormKeys(this.app, intent)

        keys.dialogSlot(this.scope)

        LOG.debug(`applyParameters ${keys.borderoId}`)
        if (initialization) {
            await this.#initialize()
        }
        if (!this.scope.gruposAtivos || this.scope.gruposAtivos.length === 0) {
            await this.#loadGruposAtivos()
        }

        return keys.allow
    }

    public override publishParameters(intent: FlipIntent): void {
        const keys = new BorderoFormKeys(this.app, intent)

        LOG.debug(`publishParameters ${keys.borderoId}`)
    }

    async #initialize() {
        LOG.debug('initialize')

        this.scope.onFormDataChange = this.action(this.handleFormDataChange)
        this.scope.onFileChange = this.action(this.handleFileChange)

        this.scope.onSave = this.action(this.handleSave)
        this.scope.onClose = this.action(this.handleClose)
    }

    async #loadGruposAtivos() {
        LOG.debug('loadGruposAtivos')
        const grupos = await grupoService.fetchGruposAtivos()
        this.scope.gruposAtivos = grupos
    }

    private async handleClose() {
        this.app.scope.dialog = undefined
        await new BorderoKeys(this.app).flip()
    }

    private async handleSave(): Promise<void> {
        try {
            const remessa = this.scope.formData
            if (!remessa.arquivo_base64 || remessa.arquivo_base64.length == 0) {
                throw new Error('Arquivo deve ser informado')
            }

            if (!remessa.grupo_id) {
                throw new Error('Grupo deve ser informado')
            }

            if (!remessa.cedente_cnpj || remessa.cedente_cnpj.trim().length === 0) {
                throw new Error('CNPJ do cedente deve ser informado')
            }

            const retSalvar = await borderoService.saveRemessaBordero(remessa)

            if (retSalvar) {
                await this.handleClose()
                this.app.notify('success', 'Salvo com sucesso')
            }
        } catch (caught) {
            LOG.error('handleSave', caught)
            this.app.notify('error', (caught as Error).message)
        }
    }

    private async handleFormDataChange(dadosAlterados: Partial<BorderoEnvio>) {
        this.scope.formData = {
            ...this.scope.formData,
            ...dadosAlterados
        }
    }

    private async handleFileChange(file: File | undefined) {
        if (file && file.name.toLowerCase().endsWith('.rem')) {
            const fileName = file.name

            const reader = new FileReader()

            reader.onload = () => {
                const result = reader.result as string
                const base64String = result.split(',')[1]

                this.scope.formData = {
                    ...this.scope.formData,
                    arquivo_nome: fileName,
                    arquivo_base64: base64String
                }
            }

            reader.readAsDataURL(file) // Lê como base64
        } else {
            this.scope.formData = { ...this.scope.formData, arquivo_nome: '', arquivo_base64: '' }
            this.app.notify('warning', 'Por favor, selecione um arquivo .REM')
        }
    }
}

export default BorderoFormPresenter
